import { render, staticRenderFns } from "./TransferFundsLisaTooltip.vue?vue&type=template&id=bcb2e296&scoped=true"
import script from "./TransferFundsLisaTooltip.vue?vue&type=script&lang=js"
export * from "./TransferFundsLisaTooltip.vue?vue&type=script&lang=js"
import style0 from "./TransferFundsLisaTooltip.vue?vue&type=style&index=0&id=bcb2e296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb2e296",
  null
  
)

export default component.exports